import { context } from '@wikia/ad-engine';

export function getOpenXContext(): object {
	const midBoxAdConfigs = context.get('experiments.midBoxAdExperiment')
		? {
				mid_boxad: {
					sizes: [[300, 250]],
					unit: '561464441',
				},
			}
		: {};

	return {
		enabled: false,
		delDomain: 'wikia-d.openx.net',
		slots: {
			featured: {
				unit: '559098632',
			},
			...midBoxAdConfigs,
		},
	};
}
